<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<div class="selector-item">
		<div>
			<label>School</label>
		</div>

		<div style="margin-left: 10px">
			<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
			<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
                [(ngModel)]="SchoolID"
                (ngModelChange)="onSchoolChange($event)">
				<option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
            </select> -->

			<caass-schoolselector [ShowAll]="false" [Disabled]="loading"> </caass-schoolselector>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onAddType()">Add Type</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onEditType()">Edit Type</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onDeleteType()">Delete Type</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onToggleType()">
			{{ ToggleText }}
		</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstSchoolIncidentType"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedSchoolIncidentType"
		dataKey="SchoolIncidentTypeID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--SchoolIncidentTypeDesc-->
				<th>
					<p-columnFilter type="text" field="SchoolIncidentTypeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolIncidentTypeCD-->
				<th>
					<p-columnFilter type="text" field="SchoolIncidentTypeCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--DefinedByDesc-->
				<th>
					<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDefinedByDesc
								[ngModel]="value"
								[options]="lstDefinedByDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--UsedByDesc-->
				<th>
					<p-columnFilter field="UsedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterUsedByDesc
								[ngModel]="value"
								[options]="lstUsedByDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="SchoolIncidentTypeDesc">Description<p-sortIcon field="SchoolIncidentTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="SchoolIncidentTypeCD">Code<p-sortIcon field="SchoolIncidentTypeCD"></p-sortIcon></th>
				<th pSortableColumn="DefinedByDesc">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
				<th pSortableColumn="UsedByDesc">Used By<p-sortIcon field="UsedByDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-SchoolIncidentType>
			<tr [pSelectableRow]="SchoolIncidentType" (dblclick)="onRowDblClick(SchoolIncidentType)">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ SchoolIncidentType[col.field] }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="SchoolIncidentType.DefinedByID <= 2 ? 'Red' : 'Black'"
				>
					{{ SchoolIncidentType.DefinedByDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ SchoolIncidentType.ActiveDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ SchoolIncidentType.UsedByDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
